import React from 'react'
import Logoar from "./pics/logo.jpeg";
import Share from "../../components/share.js";
import "./jawaan.css" 
import img from "./pics/rora.png";
const Rora = () => {    
  return  (
 
    <div className="shortstory-container">
        <img src={Logoar} alt="Logoar" className="logoarr" />
      <div className="blue-bg">
     
      
        
        <header class="entry-header">
		<h4 class="entry-meta"><a href="https://nooffensebut.vercel.app/MovieReviews" target='_blank' data-wpel-link="internal">Movie and Show Reviews</a></h4>
		<h1 class="entry-title">Rocky aur Rani ki Prem Kahani</h1>
		<div class="entry-meta">
			<span class="byline">by <span class="author vcard"><a class="url fn n" href="https://nooffensebut.vercel.app/aboutus" target='_blank' data-wpel-link="internal">Harshala</a></span></span><span class="meta-divider"> | </span><span class="posted-on"><a href="https://nooffensebut.vercel.app/content" target='_blank' rel="bookmark" data-wpel-link="internal"><time class="entry-date published" datetime="2018-03-01T07:27:10-05:00">12.10.2023</time><time class="updated" datetime="2018-03-01T11:10:42-05:00"></time></a><span>		</span></span></div>
	</header>
       
 
  <img src={img} alt="Logoar" className="moo" />

        <div className="description1-2">
            <div className="rate">Rating: 4</div> <div className="genre">Genre: Romance,Drama,Comedy</div>
            <p>The film, while following a somewhat predictable storyline, manages to captivate audiences through its compelling drama. It skillfully showcases a wide range of emotions delivered flawlessly by the talented ensemble cast, making it a worthwhile watch. The selection of actors for their respective roles is indeed praiseworthy.</p>
<br/>
<p>Ranveer Singh's portrayal of Rocky is particularly charming and endearing, adding depth to the character. Rani's recurring "Tu kya hain yaar" dialogue, after every cute scene of Rocky is indeed very heartwarming.</p>
<br/>
<p>The song "Tum kya Mile" stands out as the modern-day equivalent of the iconic "Suraj Hua Madham," delivering a melodic and romantic experience. The viral success of the "What Jumka" song since its release attests to its catchy appeal. The film's soundtrack as a whole boasts a collection of fantastic songs.</p>
<br/>
<p>Rocky's impactful statement, "Love hai toh sab hain," resonates deeply, emphasizing the theme of love transcending societal contrasts. The movie effectively emphasizes the significant role that families play in Indian marriages, making it a central theme. The importance of showing respect to one's partner's family members is a valuable message conveyed throughout the narrative.</p>
<br/>
<p>Furthermore, the film breaks stereotypes by highlighting that women can pursue their dreams and ambitions, and they aren't confined to traditional roles in the kitchen. This progressive message adds a layer of depth to the storyline.</p>
<br/>
<p>In summary, this is a delightful and entertaining romantic film that falls within the realm of typical Karan Johar movies. If you're a fan of the romance genre, it's definitely worth a watch.</p>      
          <br/>


    <hr></hr>
</div>



          <Share/>
      </div>
</div> )}

export default  Rora;

 


